import EventEmitter from 'src/helpers/EventEmitter'

const Events = {
  ONMESSAGE: 'onMessage',
  USER_INFO_REQUEST: 'userInfoRequest',
  USER_INFO_UPDATE: 'userInfoUpdate',
  USER_AUTH_REQUEST: 'userAuthRequest',
  USER_AUTH_ABORT: 'userAuthAbort',
  ADD_CHILD_REQUEST: 'addChildRequest',
  ADD_CHILD_RESPONSE: 'addChildResponse',
  FULL_USER_INFO_UPDATE: 'fullUserInfoUpdate',
  USER_AUTH_CODE_REQUEST: 'userAuthCodeRequest',
  USER_AUTH_CODE: 'userAuthCode',
  RES_SUBMIT: 'resSubmit',
  RES_SUBMITTED: 'resSubmitted',
  PAY_REQUEST: 'payRequest',
  PAY_SUCCESS: 'paySuccess',
  H5_LOADED: 'loaded',
  FACE_INFO_REQUEST: 'faceInfoRequest',
  CONNECTING: 'connecting',
  CONNECTED: 'connected',
  SCHEDULES_REQUEST: 'schedulesRequest',
  SCHEDULES: 'schedules',
  CALENDERS_REQUEST: 'schedulesRequest',
  CALENDERS: 'calenders',

  POPUP_REQUEST: 'popupRequest',
  POPUP_RESPONSE: 'popupResponse',

  CUSTOM_SERVICE: 'customService',

  INV_POPUP: 'invPopup',
  INV_ACCEPTED: 'invAccepted',
  INV_REJECTED: 'invRejected',

  SAVE_IMAGE: 5011,
  TICKET_ORDER_SUBMIT: 5001,
  TICKET_ORDER_SUBMITTED: 5002,
  FACE_VERIFY_REQUEST: 6001,
  FACE_VERIFY_RESPONSE: 6002,

  GET_PHONE_NUMBER_REQUEST: 'getPhoneNumberRequest',
  GET_PHONE_NUMBER_COMPLETE: 'getPhoneNumberComplete',
  GET_PHONE_NUMBER_FAIL: 'getPhoneNumberFail',

  JUMP_URL: 7001,
  SCAN: 7002,
  TO_MONSTER_PAGE: 'toMonsterPage',
}

// ALIPAY SERVICE
class AlipayService {
  constructor() {
    Object.assign(this, EventEmitter)
    this.isAlipay = /AlipayClient/i.test(navigator.userAgent) && window.my
  }
  init = () => {
    if (!this.isAlipay) {
      return new Promise((resolve) => {
        console.log('无法检测到小程序环境')
        resolve()
      })
    }
    return this.connect()
  }

  connect = () => {
    return new Promise((resolve) => {
      if (!this.isAlipay) {
        console.log('无法检测到小程序环境, 连接失败')
        resolve()
        return
      }
      window.my.onMessage = (e) => {
        if (e.msg === Events.CONNECTED) {
          console.log('小程序环境连接成功', e)
          this.connected = true
          window.my.onMessage = this._onMessage
          resolve(e.data.info)
        }
      }
      console.log('小程序环境连接中...')
      window.my.postMessage({ msg: Events.CONNECTING })
    })
  }

  sendMessage = (msg) => {
    window.my.postMessage(msg)
  }

  sendEvent = (evt, data = {}) => {
    window.my.postMessage({
      event: evt,
      data: data,
    })
  }

  _onMessage = (e) => {
    this.emit(Events.ONMESSAGE, e)
  }
}
let service = new AlipayService()
service.Events = Events
export default service
window.AlipayService = service
